export const buildCollectionsUpdateData = (altText, collection) => {
  var _collection$coverImag;
  return {
    collection: {
      ...collection,
      coverImage: {
        ...collection.coverImage,
        imageInfo: {
          ...((_collection$coverImag = collection.coverImage) == null ? void 0 : _collection$coverImag.imageInfo),
          altText
        }
      }
    },
    mask: ['coverImage.imageInfo.altText']
  };
};
export const buildPortfolioCollectionsBulkUpdatePayload = (altTextData, portfolioCollectionsMap) => {
  const payload = {
    collections: []
  };
  altTextData.forEach(_ref => {
    let {
      id,
      alt,
      entityId
    } = _ref;
    const portfolioCollection = portfolioCollectionsMap.get(entityId || '');
    if ((portfolioCollection == null ? void 0 : portfolioCollection.id) === id) {
      payload.collections.push(buildCollectionsUpdateData(alt, portfolioCollection));
    }
  });
  return payload;
};
//# sourceMappingURL=bulk-update-portfolio-collections-alt-text-payload.js.map